export default "__VITE_ASSET__727cf8f7__"